<template>
  <header
    class="px-10"
  >
    <div
      class="width-lg mx-auto"
    >
      <div
        class="xl:flex xl:items-end mt-6 xl:mt-12"
      >
        <div
          class="xl:flex-shrink"
        >
          <img
            v-if="branded"
            alt="The Group Logo"
            class="mb-6 xl:mb-0 xl:mr-4 mx-auto xl:mx-0"
            src="../assets/tgi-logo-vert.png"
            :style="{ height: '57px' }"
          >
        </div>
        <div
          class="xl:flex-1 font-light leading-none text-center xl:text-left"
        >
          <div
            v-if="!isEmptyString(property.getAddress())"
            :style="{ fontSize: $breakpoint.xlAndUp ? '34px' : '20px' }"
          >
            {{ property.getAddress() }}
          </div>
          <div
            v-if="!isEmptyString(property.getAddressSecondary())"
            class="mt-1 xl:mt-2"
            :style="{ fontSize: '20px' }"
          >
            {{ property.getAddressSecondary() }}
          </div>
        </div>
        <div
          class="flex xl:block flex-col-reverse xl:flex-shrink text-center xl:text-right mb-4 xl:mb-0"
        >
          <StatusCircle
            v-if="!isEmptyString(property.listing.mls_status)"
            class="mt-4 xl:mt-0"
            :value="property.listing.mls_status"
          />
          <PropertySpecs
            class="mt-4 text-base xl:text-xl font-normal xl:font-light"
            :property="property"
          />
        </div>
      </div>
      <div class="xl:flex gap-10">
        <div
          class="hidden xl:block xl:py-8 flex-grow"
        >
          <Skeleton
            v-if="loading"
            :height="20"
          />
          <div
            v-else
            class="text-sm tracking-wide font-light uppercase"
          >
            <ul
              class="flex flex-row justify-between"
            >
              <MenuItems
                :items="menuItems"
              />
            </ul>
          </div>
        </div>
        <div
          v-if="shouldShowVirtualTourButton"
          class="py-5"
        >
          <VirtualTourBtn :property="property" />
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { isEmptyString } from 'mytribus-commons';

import MenuItems from '../components/MenuItems.vue';
import PropertySpecs from '../components/PropertySpecs.vue';
import Skeleton from '../components/Skeleton.vue';
import StatusCircle from '../components/StatusCircle.vue';
import VirtualTourBtn from '../components/VirtualTourBtn.vue';

export default {
  name: 'PropertyHeader',

  components: {
    VirtualTourBtn,
    MenuItems,
    PropertySpecs,
    Skeleton,
    StatusCircle,
  },

  props: {
    branded: {
      required: true,
      type: Boolean,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    menuItems: {
      required: true,
      type: Object,
    },
    property: {
      required: true,
      type: Object,
    },
    shouldShowVirtualTourButton: {
      type: Boolean,
      required: true,
    },
  },

  computed: {
    /** @type {string} */
    formattedPrice() {
      const {
        close_price: closePrice = null,
        list_price: listPrice = null,
      } = this.property.listing.price;

      const [shownPrice] = [closePrice, listPrice]
        .map((price) => parseInt(price, 10))
        .filter((price) => price);

      if (!shownPrice) {
        return 'No Price';
      }

      return `$${shownPrice.toLocaleString()}`;
    },
  },

  methods: {
    /** @return {boolean} */
    isEmptyString,
  },
};
</script>
